<template>
  <div class="new_chart_container">
    <ChartHeader
      v-if="showTitle"
      :stockInfo="stockInfo"
      :isCreateView="isCreateView"
    />
    <apexchart
      v-if="data && data.length"
      type="bar"
      :options="option"
      :series="seriesData"
      height="100%"
      width="100%"
    >
    </apexchart>
  </div>
</template>
<script lang="ts">
import IconComponent from "@/components/IconComponent.vue";
import ChartHeaderModel from "../../models/chartHeader.model";
import { GeneralStockModel } from "../../models/generalstock.model";
import { StockMarkets } from "../../models/stocks.model";
import firebaseService from "@/services/firebase.service";
import httpService from "@/services/http.service";
import utilService from "@/services/util.service";
import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  ref,
  watch,
} from "vue";
import VueApexCharts from "vue3-apexcharts";
import ChartHeader from "./chartHeader.vue";
import filters from "@/helpers/filters";
import moment from "moment";

export default defineComponent({
  components: {
    apexchart: VueApexCharts,
    IconComponent,
    ChartHeader,
  },
  props: {
    showTitle: {
      type: Boolean,
      default: true,
    },
    legends: {
      type: Boolean,
      default: true,
    },
    widget: {
      type: Object,
    },
    backgroundColor: {
      type: String,
      default: filters.getComputedVariable("--card-inner-color-profile"),
    },
    data: {
      type: Object,
    },
    showGrid: {
      default: false,
    },
    isPreview: {
      default: false,
    },
    xAxisType: {
      type: String,
      default: "category",
    },
    isHorizontal: {
      type: Boolean,
      default: false,
    },
    isCreateView: {
      type: Boolean,
      default: false,
    },
    colorsArr: {
      type: Object,
      default: null,
    },
    calculateColors: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    let data = ref<any[]>([]);

    let stockInfo = ref<ChartHeaderModel>();

    const seriesData = computed(() => {
      return utilService
        .generateSeriesForChart(data.value)
        .map((dataObject) => {
          if (Array.isArray(dataObject?.data)) {
            const sortedData = [...dataObject.data].sort(
              (a, b) => moment(a.x).valueOf() - moment(b.x).valueOf()
            );
            const times = sortedData.map((row) => moment(row.x));
            const minTime = moment.min(times);
            const maxTime = moment.max(times);
            const hoursDiff = maxTime.diff(minTime, "hours");
            const formatString = hoursDiff <= 24 ? "HH:mm:ss" : "MM/DD";

            return {
              ...dataObject,
              data: sortedData.map((row) => ({
                x: moment(row.x).format(formatString),
                y: row.y,
              })),
            };
          }
          return dataObject;
        });
    //   return utilService.generateSeriesForChart(data.value ?? [])
    });

    const series = ref([
      {
        name: "Stock Price",
        data: [
          { x: "2025-01-22", y: 120 },
          { x: "2025-01-23", y: 125 },
          { x: "2025-01-24", y: 130 }, // No weekends in data
          { x: "2025-01-27", y: 135 },
          { x: "2025-01-28", y: 140 },
          { x: "2025-01-29", y: 145 },
          { x: "2025-02-01", y: 150 },
          { x: "2025-01-02", y: 155 },
          { x: "2025-01-03", y: 160 },
        ],
      },
    ]);

    const getlengends = computed(() => {
      return data.value.map((item: any) => {
        return item.name;
      });
    });

    
    var option = computed(() => {
      const totalLabels = seriesData.value?.[0]?.data?.length || 0;
      return {
        chart: {
          width: "100%",
          type: "line",
          foreColor: filters.getComputedVariable("--chart-legend"),
          fontFamily: "Roboto, Arial, sans-serif",
          animations: {
            enabled: false,
            easing: "easeout",
            speed: 200,
          },
          toolbar: {
            show: true,
            offsetX: -25,
            offsetY: 20,
            tools: {
              download: false,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
              customIcons: [],
            },
            export: {
              csv: {
                filename: undefined,
                columnDelimiter: ",",
                headerCategory: "category",
                headerValue: "value",
              },
              svg: {
                filename: undefined,
              },
              png: {
                filename: undefined,
              },
            },
            autoSelected: "zoom",
          },
        },
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          bar: {
            // groupPadding: 0,
            // pointPadding: 0,
            // gaps: "zero",
            // rangeBarOverlap: true,
            horizontal: props.isHorizontal,
            // hideZeroBarsWhenGrouped: true,
            columnWidth: "70%",
          },
        },
        grid: {
          show: props.showGrid,
          borderColor: filters.getComputedVariable("--chart-legend"),
        },
        markers: {
          size: 0,
          style: "hollow",
        },
        stroke: {
          // colors: ['transparent'],
          curve: "smooth",
          width: 1,
        },
        xaxis: {
          type: props.xAxisType,
          tickAmount: totalLabels > 60 ? 60 : totalLabels, // max 60 ticks
          labels: {
            show: props.legends,
            rotate: -65,
            style: {
              colors: filters.getComputedVariable("--chart-legend"),
              fontSize: "10px",
            },
          },
          // type: props.xAxisType,
          // labels: {
          //     formatter: function (val, timestamp) {
          //     return new Date(timestamp).toLocaleDateString();
          //     },
          // },
          axisBorder: {
            show: props.legends,
            color: filters.getComputedVariable("--chart-legend"),
            width: "100%",
          },
          axisTicks: {
            show: props.legends,
            color: filters.getComputedVariable("--chart-legend"),
            borderType: "solid",
            width: 4,
          },
        },
        // yaxis: {
        //   show: false,
        // },
        yaxis: {
          show: props.legends,
          labels: {
            align: "left",
            style: {
              colors: filters.getComputedVariable("--chart-legend"),
              fontSize: "11px",
            },
            formatter: function (value: any) {
              return filters.systemNumberConventionOld(value, true);
            },
          },
          axisBorder: {
            show: props.legends,
            color: filters.getComputedVariable("--chart-legend"),
            width: 2,
          },
          axisTicks: {
            show: props.legends,
            color: filters.getComputedVariable("--chart-legend"),
            borderType: "solid",
            width: 4,
          },
        },
        tooltip: {
          x: {
            format: props.xAxisType == "datetime" ? "dd MMM" : null,
          },
          y: {
            formatter: (name: any) => {
              return name;
            },
          },
        },
        legend: {
          show: true,
          showForSingleSeries: false,
          // formatter: function (seriesName: any, opts: any) {
          //   if (props.xAxisType != "dateTime") {
          //     return seriesName;
          //   }
          //   if (opts.w.globals.seriesNames[opts.seriesIndex] != undefined) {
          //     return opts.w.globals.seriesNames[opts.seriesIndex];
          //   }
          // },
          labels: {
            colors: [filters.getComputedVariable("--text-color")],
          },
          markers: {
            radius: 50,
          },
        },
        colors:
          props.colorsArr && props.calculateColors
            ? [
                function (seriesIndex: any, dataIndex: any) {
                  if (props.colorsArr) {
                    return props.colorsArr[seriesIndex.dataPointIndex];
                  } else {
                    return [filters.getComputedVariable("--text-alt-color")];
                  }
                },
              ]
            : props.colorsArr,
        // colors: props.colorsArr ?? ["#8B77CF", "#ffffff", "#00fff6", "#fb267b"],
      };
    })

    let timeout: any;

    watch(
      () => props.widget,
      () => {
        if (
          stockInfo.value &&
          props.widget &&
          props.widget!.customData &&
          props.widget!.customData.stock &&
          stockInfo.value.symbol != props.widget!.customData.stock.symbol
        ) {
          data.value = [];
          stockInfo.value = undefined;
          updateChartData();
        }
      },
      { deep: true }
    );

    onUnmounted(() => {
      if (timeout) {
        clearTimeout(timeout);
      }
    });

    onMounted(async () => {
      if (props.widget) {
        if (!props.widget!.customData.chartData) {
          updateChartData();
        } else {
          data.value = props.widget!.customData.chartData;
          if (props.widget!.customData.stock) {
            stockInfo.value = GeneralStockModel.getChartHeader(
              props.widget!.customData.stock
            );
          }
          window.dispatchEvent(new Event("resize"));
        }
      }
    });

    const getStocks = async () => {
      let response = httpService
        .getstocks(props.widget!.customData.stock.symbol)
        .then((response) => {
          if (response.data.isSuccess) {
            stockInfo.value = response.data.data[0];
          }
        });
    };

    const getCryptos = async () => {
      let response = httpService
        .getCryptos(props.widget!.customData.stock.symbol)
        .then((response) => {
          if (response.data.isSuccess) {
            stockInfo.value = response.data.data[0];
          }
        });
    };

    const updateChartData = async (isFirst: boolean = true) => {
      if (
        props.widget!.customData.stock &&
        props.widget!.customData.stock.symbol
      ) {
        if (isFirst) {
          if (props.widget!.customData.stock.symbol!) {
            firebaseService
              .getChartHeader(props.widget!.customData.stock.symbol!)
              .then((val) => {
                if (val) {
                  stockInfo.value = val;
                }
              });
          }
          firebaseService
            .getStockChart(
              props.widget!.customData.stock.symbol!,
              props.widget!.customData.duration,
              props.widget!.customData.interval,
              props.widget!.styleType,
              props.widget!.customData.dataType
            )
            .then((arr: any[]) => {
              data.value = arr;
              getBarChartData();
            });
        } else {
          getBarChartData();
        }
        if (!stockInfo.value || isFirst) {
          if (props.widget!.customData.stock.type == StockMarkets.stocks) {
            getStocks();
          } else {
            getCryptos();
          }
        }
      }
    };

    const getBarChartData = async () => {
      if (
        props.widget!.customData &&
        props.widget!.customData.dataType &&
        props.widget!.customData.dataType.length
      ) {
        var apiUrl = utilService.getChartType(
          "bar",
          props.widget!.customData.stock.type
        )?.apiUrl!;
        if (props.widget && props.widget.apiUrl && !apiUrl) {
          apiUrl = props.widget.apiUrl;
        }
        apiUrl =
          apiUrl +
          utilService.getChartQuery(
            props.widget!.customData.stock.symbol!,
            props.widget!.customData.duration,
            props.widget!.customData.interval,
            props.widget!.customData.dataType,
            props.widget!.customData.stock.type,
            props.widget!.customData.stock.stockId
          );
        httpService.getData(apiUrl).then((res) => {
          if (res.data.isSuccess) {
            data.value = res.data.data;
          }
          if (!props.isPreview) {
            timeout = setTimeout(async () => {
              updateChartData(false);
            }, utilService.liveUpdateDuration);
          }
        });
      }
    };

    return {
      seriesData,
      data,
      stockInfo,
      option,
      series,
    };
  },
});
</script>
<style lang="scss" scoped>
.apexcharts-legend {
  padding: 0 !important;
}

.new_chart_container {
  height: calc(100% - 45px);
  width: 100%;
  display: flex;
  flex-flow: column;
  padding: 0 15px;
  .vue-apexcharts {
    margin: 0 -5px 0 -15px;
  }

  &.widgets_chart {
    height: calc(100% - var(--custom-margin) - 30px);
  }

  &.stockCard {
    .vue-apexcharts {
      margin: 0;
    }
  }
}

.chart {
  height: 100%;
  width: 100%;
  max-height: calc(100% - 60px);
}

</style>
